export const getOrderDiscountAmount = order => {
  if (!order) {
    return null;
  }

  return order.subtotal_before_discounts - order.subtotal;
};

// Public link a guest can open to follow a kiosk order (printed on receipts and
// rendered as a QR code on the success screen).
export const getKioskOrderLink = (
  session,
  uniqueOrderNumber,
  { force } = {}
) => {
  if (!session || !uniqueOrderNumber) {
    return null;
  }

  const baseUrl = process.env.VUE_APP_BASE_URL.includes('localhost')
    ? 'http://app-stage.greet.menu'
    : process.env.VUE_APP_BASE_URL;

  return `${baseUrl}/view-kiosk-order/${session}/${uniqueOrderNumber}${
    force ? '?force=1' : ''
  }`;
};
